'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.updatePageOffset_E76660v1 = updatePageOffset_E76660v1;
exports.updateMapPageOffset_E76660v1 = updateMapPageOffset_E76660v1;
exports.updateListPageOffset_E76660v1 = updateListPageOffset_E76660v1;
exports.updateStitek_3D7ECFv1 = updateStitek_3D7ECFv1;
exports.updateMapStitek_3D7ECFv1 = updateMapStitek_3D7ECFv1;
exports.updateListStitek_3D7ECFv1 = updateListStitek_3D7ECFv1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-06-17T17:59:10Z                      #

// ##############################################################

function updatePageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'PageOffsetVO'
    });

    return result;
}

function updateMapPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updatePageOffset_E76660v1(data[key]);
    });
    return result;
}

function updateListPageOffset_E76660v1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updatePageOffset_E76660v1);
}

function updateStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    var result = (0, _extends3.default)({}, data, {
        '@class': data['@class'] ? data['@class'] : 'StitekVO'
    });

    if (typeof data.adresat !== "undefined") {
        result.adresat = { id: result.adresat.id };
    }
    if (typeof data.adresa !== "undefined") {
        result.adresa = { id: result.adresa.id };
    }

    return result;
}

function updateMapStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    var result = {};
    (0, _keys2.default)(data).forEach(function (key) {
        result[key] = updateStitek_3D7ECFv1(data[key]);
    });
    return result;
}

function updateListStitek_3D7ECFv1(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateStitek_3D7ECFv1);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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